import React from 'react';
import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { IntakeFormCustomQuestionResponse } from '@spike/model';

interface ResponseCardProps {
    response: IntakeFormCustomQuestionResponse;
}

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            gap: 8,
            display: 'flex',
            flexDirection: 'column',
            width: '100%',
            borderRadius: 18,
            padding: '16px 24px',
            backgroundColor: '#FFFFFF',
            border: 'solid 1px #D4D4D4'
        },
        title: {
            margin: 0,
            fontSize: 16,
            lineHeight: 1,
            fontWeight: 600,
            color: '#000000'
        },
        description: {
            margin: 0,
            fontSize: 15,
            lineHeight: 1.4,
            fontWeight: 400,
            color: '#000000'
        }
    })
);

export const ResponseCard: React.FC<ResponseCardProps> = props => {
    const classes = useStyles();

    return (
        <div className={classes.root}>
            <h5 className={classes.title}>{props.response.question}</h5>
            <p className={classes.description}>{props.response.answer}</p>
        </div>
    );
};
